/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Error_Messages_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Error Messages List" |
*
* @param {Style_Guide_Error_Messages_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_error_messages_aria_label = /** @type {((inputs?: Style_Guide_Error_Messages_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Error_Messages_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des messages d'erreur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste der Fehlermeldungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco dei messaggi di errore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список сообщений об ошибках")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de mensajes de error")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误消息列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーメッセージリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि संदेशों की सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de mensagens de erro")
	return /** @type {LocalizedString} */ ("Error Messages List")
});